export default "__VITE_ASSET__9NK4eAvF__"